import { render, staticRenderFns } from "./ListAbsenceFeatured.vue?vue&type=template&id=f8af11f4&scoped=true&"
import script from "./ListAbsenceFeatured.vue?vue&type=script&lang=js&"
export * from "./ListAbsenceFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListAbsenceFeatured.vue?vue&type=style&index=0&id=f8af11f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8af11f4",
  null
  
)

export default component.exports